import { ChangeDetectionStrategy, Component, effect, input, output, viewChild } from '@angular/core';
import { AttendeeDropdownItem, AttendeesDropdownComponent } from '@assist/ui/attendees-dropdown';
import { ButtonComponent } from '@cue/assist/ui/buttons';
import { translation } from '@cue/translations';
import { cueAdd } from '@cue/ui/icons';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'assist-new-reservation-attendee-picker',
  templateUrl: './new-reservation-attendee-picker.component.html',
  styleUrl: './new-reservation-attendee-picker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AttendeesDropdownComponent, ButtonComponent, TranslocoPipe],
})
export class NewReservationAttendeePickerComponent {
  readonly active = input(false);
  readonly value = input.required<AttendeeDropdownItem[]>();
  readonly customEmail = input<string | null>(null);

  readonly openPicker = output<void>();
  readonly valueChange = output<AttendeeDropdownItem[] | AttendeeDropdownItem | null>();
  readonly filterValueChange = output<string>();
  readonly addCustomEmail = output<string>();

  private readonly attendeePicker = viewChild(AttendeesDropdownComponent);

  readonly translation = translation;
  readonly icons = {
    cueAdd,
  };

  private readonly openDropdownWhenActive = effect(() => {
    if (!this.active()) {
      return;
    }

    const attendeePicker = this.attendeePicker();

    if (!attendeePicker) {
      return;
    }

    queueMicrotask(() => attendeePicker.open());
  });

  onOpenPicker(event: Event) {
    event.preventDefault();
    this.openPicker.emit();
    queueMicrotask(() => this.attendeePicker()?.open());
  }

  onAddCustomEmail(event: Event, email: string) {
    event.preventDefault();
    this.addCustomEmail.emit(email);
  }
}
